import { Injectable, EventEmitter, Output, Component } from '@angular/core';
import { Router } from '@angular/router';
import { soundManager } from 'soundmanager2';
import { LoggingService, AuthService, UserService, SongsService, PlaylistService, MessagesServices } from '../../api';
import * as _ from 'lodash';
import { Globals } from '../../app.globals';
import { MdDialog, MdDialogRef } from '@angular/material';
import { API } from '../../api/services/api.service';
import { Http } from '@angular/http';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class PlayerService {
  private currentTrack = null;
  private repeat = null;
  private autoPlay = true;
  private autoPlayPlaylist = true;
  private isPlaying = false;
  private volume = 90;
  private trackProgress = 0;
  private trackPostion = 0;
  private playlist = [];
  playlistList = [];
  private playlistQue = [];
  private playlistQue2 = [];
  private loading: boolean = false;
  private radioStations = [];
  dialogRef: MdDialogRef<any>;
  private messages: any = new Array<any>();
  msg1: any = '';
  title1: any = '';
  msg2: any = '';
  title2: any = '';
  nowListen: number = 0;
  playingId: number = 0;
  songDuration: number;
  public timeLogChanged: BehaviorSubject<number> = new BehaviorSubject<number>(0);
  public timeRestriction: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  // to check the songs plays and listens
  public listenToSongCount: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  // to check the songs plays and listens
  public songRemovedFromQueue: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  // to pass song to add to queue component for album view
  public isSongInQueue: BehaviorSubject<any> = new BehaviorSubject<any>([]);
  // to pass song to add to queue component for album view
  public isSongPlayingStatus: BehaviorSubject<boolean> = new BehaviorSubject<any>(false);
  vol: number = 90;
  @BlockUI() blockUI: NgBlockUI;
  @Output() playerEvent: EventEmitter<any> = new EventEmitter();

  constructor(private http: Http, private api: API, private loggingService: LoggingService, private sm: MessagesServices, private authService: AuthService, private userService: UserService,
    private songService: SongsService, public dialog: MdDialog, public playlistService: PlaylistService) {
    this.init();
  }

  /***
   * close menu
   */
  closeMenu() {
    if (screen.width <= 1024) {
      var btn = document.getElementById("123");
      btn.click();
    }
  }
  /**
  *close menu end
  **/

  /**
  * setting system messages
  **/
  setMessages() {
    this.msg1 = '';
    this.title1 = '';
    if (this.messages) {
      for (var i = 0; i < this.messages.length; i++) {
        if (this.messages[i].event == 'WG_EVENT_SONG_LISTEN_QUOTA_EXCEEDED_FOR_LOGGED_IN_USER') {
          this.title1 = this.messages[i].title;
          this.msg1 = this.messages[i].message;
        }
        if (this.messages[i].event == 'WG_EVENT_SONG_LISTEN_QUOTA_EXCEEDED_FOR_VISITORS') {
          this.title2 = this.messages[i].title;
          this.msg2 = this.messages[i].message;
        }
      }
    }
  }

  init() {
    let that = this;
    if (typeof soundManager === 'undefined') {
      alert('Please include SoundManager2 Library!');
    }
    if (localStorage.getItem('volumePreference')) {
      this.volume = parseInt(localStorage.getItem('volumePreference'));
      this.adjustVolumeSlider(this.volume);
    }
    soundManager.setup({
      //url: '/path/to/swfs/',
      //flashVersion: 9,
      preferFlash: false, // prefer 100% HTML5 mode, where both supported
      debugMode: false, // enable debugging output (console.log() with HTML fallback)
      useHTML5Audio: true,
      onready: function () {
      },
      ontimeout: function () {
        alert('SM2 failed to start. Flash missing, blocked or security error?');
      },
      defaultOptions: {
        // set global default volume for all sound objects
        autoLoad: false, // enable automatic loading (otherwise .load() will call with .play())
        autoPlay: false, // enable playing of file ASAP (much faster if "stream" is true)
        autoPlayPlaylits: this.autoPlayPlaylist,
        from: null, // position to start playback within a sound (msec), see demo
        loops: 1, // number of times to play the sound. Related: looping (API demo)
        multiShot: false, // let sounds "restart" or "chorus" when played multiple times..
        multiShotEvents: false, // allow events (onfinish()) to fire for each shot, if supported.
        onid3: null, // callback function for "ID3 data is added/available"
        onload: null, // callback function for "load finished"
        onstop: null, // callback for "user stop"
        onfailure: 'nextTrack', // callback function for when playing fails
        onpause: null, // callback for "pause"
        onplay: null, // callback for "play" start
        onresume: null, // callback for "resume" (pause toggle)
        position: null, // offset (milliseconds) to seek to within downloaded sound.
        pan: 0, // "pan" settings, left-to-right, -100 to 100
        stream: true, // allows playing before entire file has loaded (recommended)
        to: null, // position to end playback within a sound (msec), see demo
        type: 'audio/mp3', // MIME-like hint for canPlay() tests, eg. 'audio/mp3'
        usePolicyFile: false, // enable crossdomain.xml request for remote domains (for ID3/waveform access)
        volume: this.volume, // self-explanatory. 0-100, the latter being the max.
        whileloading: function () {
          let trackLoaded = ((this.bytesLoaded / this.bytesTotal) * 100);
          that.playerEvent.emit({ type: 'track:loaded', data: trackLoaded });
        },
        whileplaying: function () {
          //broadcast current playing track id
          that.currentTrack = this.id;
          //broadcast current playing track progress
          that.trackPostion = this.position;
          that.songDuration = this.duration;
          that.trackProgress = ((this.position / this.duration) * 100);
          that.playerEvent.emit({ type: 'track:progress', data: that.trackProgress });
          //broadcast track position
          that.playerEvent.emit({ type: 'currentTrack:position', data: this.position });
          //broadcast track duration
          that.playerEvent.emit({ type: 'currentTrack:duration', data: this.duration });
        },
        onfinish: function () {
          that.logTimePlayed();
          if (that.autoPlay === true) {
            //play next track if autoplay is on
            //get your angular app
            that.nextTrack();
            that.playerEvent.emit({ type: 'track:id', data: that.currentTrack });
          }
        }
      }
    });
    soundManager.onready(function () {
      let isSupported = soundManager.ok();
      that.playerEvent.emit({ type: 'angularPlayer:ready', data: true });
    }, {});
  }

  public getIcestat(url) {
    return this.api.get(url);
  }

  logTimePlayed(res?:any) {
    let min = (this.trackPostion / 1000 / 60) << 0,
    sec = Math.round((this.trackPostion / 1000) % 60);
    let second = (min * 60) + sec;
    if (second > 0) {
      if(typeof res !== undefined) {
        let trackId = this.getCurrentTrack();
        let tracking_id = localStorage.getItem('played_' + trackId);
        let params = { tracking_id: tracking_id, duration: res };
        this.loggingService.logEntity('time', params).subscribe((res) => {
        });
      } else {
        let trackId = this.getCurrentTrack();
        let tracking_id = localStorage.getItem('played_' + trackId);
        let params = { tracking_id: tracking_id, duration: second };
        this.loggingService.logEntity('time', params).subscribe((res) => {
        });
      }
    }
  }

  checkRadio() {
    localStorage.setItem("response", '0');
    this.getIcestat("api/radio").toPromise().then((data) => {
      localStorage.setItem("response", '1');
      if (!data || !data.icestats || !data.icestats.source || !(data.icestats.source instanceof Array)) {
        return false;
      }
      if (data && data.icestats != null && data.icestats.source != null && (data.icestats.source instanceof Array)) {
        if (this.radioStations.length == 0) {
          this.radioStations = data.icestats.source;
          this.radioStations.forEach((arrayItem) => {
            let station = _.find(this.radioStations, {
              listenurl: arrayItem.listenurl
            });
            this.sendRadioSongInfo(station);
          });
        } else {
          data.icestats.source.forEach((arrayItem) => {
            let station = _.find(this.radioStations, {
              listenurl: arrayItem.listenurl
            });
            if (station) {
              if (station.title && station.title != arrayItem.title) {
                this.sendRadioSongInfo(arrayItem);
              }
            }
          });
        }
      }
    })
  }

  sendRadioSongInfo(station) {
    let id, radioId, index;
    if (station) {
      if (station.title) {
        id = station.title.substring((station.title.lastIndexOf('(') + 1), (station.title.lastIndexOf(')')));
        if (station.listenurl) {
          radioId = station.listenurl.substring((station.listenurl.lastIndexOf('/') + 1), (station.listenurl.lastIndexOf('.')))
          index = _.findIndex(this.radioStations, {
            listenurl: station.listenurl
          });
          if (id != '') {
            this.songService.getSongDetailBySlug(id).subscribe((res) => {
              this.radioStations[index] = station;
              this.radioStations[index].currentSong = res;
              let dataToSend = {
                listenurl: station.listenurl,
                radio: radioId,
                title: station.title,
                listeners: station.listeners,
                songId: id,
                songDetail: res
              };
              this.broadcastRadioSongDetail(dataToSend);
            })
          }
        }
      }
    }
  }

  setCurrentTrackId(id) {
    this.currentTrack = id;
  }

  /**
   * To check if value is in array
   */
  isInArray(array: any, value) {
    for (let i = 0; i < array.length; i++) {
      if (array[i].id === value) {
        return i;
      }
    }
    return null;  //because false is not an array index
  }

  /**
   * getIndexByValue used by this factory
  */
  getIndexByValue(array: any, value) {
    for (let i = 0; i < array.length; i++) {
      if (array[i] === value) {
        return i;
      }
    }
    return null;
  }

  /**
   * getIndexByValue used by this factory
   */
  getIndexByValue1(array: any, value) {
    for (let i = 0; i < array.length; i++) {
      if (array[i].id === value.id) {
        return i;
      }
    }
    return null;
  }

  /**
   * asyncLoop used by this factory
   */
  asyncLoop(o) {
    let i = -1;
    let loop = function () {
      i++;
      if (i == o.length) {
        o.callback();
        return;
      }
      o.functionToLoop(loop, i);
    };
    loop(); //init
  }

  /**
   * Sets Current Track
   */
  setCurrentTrack(key) {
    this.currentTrack = key;
  }

  /**
   * Fetch Current Track
   */
  getCurrentTrack() {
    return this.currentTrack;
  }

  /**
   * Fetch Current Track data
   */
  currentTrackData() {
    let trackId = this.getCurrentTrack();
    if (this.playlist.length == 0) {
      this.playlist = this.playlistQue;
    }
    let currentKey = this.isInArray(this.playlist, trackId);
    return this.playlist[currentKey];
  }

  /**
   * Fetch Current Track data
   */
  currentTrackData2() {
    let currentTrackKey = this.getIndexByValue(soundManager.soundIDs, this.getCurrentTrack());
    let nextTrackKey = +currentTrackKey + 1;
    let nextTrack = soundManager.soundIDs[nextTrackKey];
    let currentKey = this.isInArray(this.playlist, nextTrack);
    return this.playlist[currentKey];
  }

  /**
   * Get Playlist by Key
   */
  getPlaylist(key = 'undefined') {
    if (key === 'undefined') {
      return this.playlist;
    } else {
      return this.playlist[key];
    }
  }

  getPlaylistQue() {
    return this.playlistQue;
  }

  /**
   * Add to Playlist
   */
  addToPlaylist(track) {
    this.playlist.push(track);
    //broadcast playlist
    this.playerEvent.emit({ type: 'player:playlist', data: this.playlist });
  }

  addToPlaylistQue(track) {
    this.playlistQue.push(track);
    //broadcast playlist
    this.playlistQue = _.uniqBy(this.playlistQue, 'id');
    this.playerEvent.emit({ type: 'player:playlist', data: this.playlistQue });
  }
  //for single song to not padd in
  addToPlaylistQue2(track) {
    this.playlistQue2 = [];
    this.playlistQue2.push(track);
  }
  /**
  * Veriry Track Validation
  */
  isTrackValid(track: any = 'undefined') {
    if (typeof track === 'undefined') {
      return false;
    }

    if (track.url.indexOf("soundcloud") > -1) {
      //if soundcloud url
      if (typeof track.url === 'undefined') {
        return false;
      }
    } else {
      if (soundManager.canPlayURL(track.url) !== true) {
        return false;
      }
    }
  }

  /**
   * Check to Add Track to Que
   */
  checkifsonginQue(track) {
    let inArrayKey = this.isInArray(this.getPlaylist(), track.id);
    return inArrayKey;
  }

  /**
  * Add Track to Que
  */
  addTrack(track) {
    //check if track itself is valid and if its url is playable
    if (!this.isTrackValid) {
      return null;
    }
    //check if song already does not exists then add to playlist
    let inArrayKey = this.isInArray(this.getPlaylist(), track.id);
    if (inArrayKey === null) {
      //add to sound manager
      soundManager.createSound({
        id: track.id,
        url: track.mp3_url
      });
      //add to playlist
      let trackData: any = _.pick(track, ['_type', 'artist_id',
        'id', 'name', 'mp3_url', 'slug', 'belongsToRadio', 'logData', 'type']);
      trackData.metaData = _.pick(track, ['_type', 'artist', 'album', 'id', 'slug', 'name', 'image', 'type', 'length', 'discoveredByMe', 'favoritedByMe', 'favoritesCount', 'is_explicit_content']);
      if (track._type === 'playlist' && track.type === 'R') {
        trackData.metaData._type = 'song';
      } else {
        this.addToPlaylistQue(trackData);
      }
      this.addToPlaylist(trackData);
    }
    return track.id;
  }

  /**
  * Remove Song from Que
  */
  removeSong(song) {
    //if this song is playing stop it
    if (song.id === this.currentTrack) {
      this.stop();
    }
    //unload from soundManager
    soundManager.destroySound(song);
    let index = this.getIndexByValue1(this.playlist, song);
    //remove from playlist
    this.playlist.splice(index, 1);
    index = this.getIndexByValue1(this.playlistQue, song);
    this.playlistQue.splice(index, 1);
    //once all done then broadcast
    this.playerEvent.emit({ type: 'player:playlist', data: this.playlist });
    this.playerEvent.emit({ type: 'player:playlist', data: this.playlistQue });
  }

  removePlaylist(id) {
    let index = this.getIndexByValue1(this.playlistList, id);
    //remove from playlist
    this.playlistList.splice(index, 1);
  }

  /**
  * Initialize Track
  */
  initPlayTrack(trackId, isResume = false) {
    this.messages = this.sm.messags;
    this.setMessages();
    // to adjust the volume when switch the song
    if(localStorage.getItem('volumePreference')) {
      this.volume = parseInt(localStorage.getItem('volumePreference'));
      this.adjustVolumeSlider(this.volume);
    }
    if(isResume !== true) {
      //stop and unload currently playing track
      this.stop();
      this.playingId = trackId;
      //set new track as current track
      this.setCurrentTrack(trackId);
      // decide whether user should listen full song or just a preview
      let currentSong = this.currentTrackData();
      if(typeof (currentSong.type) === 'undefined'){
        currentSong.type = '';
      }
      let packageId = localStorage.getItem("package");
      if(packageId != '5') {
        //soundManager.sounds[trackId].url = currentSong.mp3_url.replace(/http/gi, "https");
        if(currentSong.type !== 'R') {
          soundManager.sounds[trackId].url = currentSong.mp3_url.replace(/http/gi, "https");
        }
        
        setTimeout(() => {
          soundManager.play(trackId);
          this.playerEvent.emit({ type: 'track:id', data: trackId });
          this.isPlaying = true;
          this.playerEvent.emit({ type: 'music:isPlaying', data: this.isPlaying });
        }, 1000);
        return;
      }
      /*  Making sure about users's limit an sending demo song if the limit is exceeded*/
      if(typeof (currentSong._type) !== 'undefined' && typeof (currentSong.type) !== 'undefined' && (currentSong._type !== 'playlist' && currentSong.type !== 'R')) {
        this.userService.userSongsPlayedCount().subscribe((res) => {
          if(res && res.count && res.limit != -1 && (parseInt(res.count) >= parseInt(res.limit))) {
            this.nowListen = this.nowListen + 1;
            localStorage.setItem("listenCount", (this.nowListen) + "");
            let Nowcount: number = parseInt(localStorage.getItem("listenCount"));
            let shortenedS3 = 'https://mspro-shortened.s3.';
            let currentTrackUrl: string = currentSong.mp3_url.split('.s3.')[1];
            soundManager.sounds[trackId].url = currentSong.mp3_url.replace(/http/gi, "https"); //shortenedS3 + currentTrackUrl;
            if((Nowcount + parseInt(res.limit)) >= parseInt(res.limit) + 1) {
              this.dialogRef = this.dialog.open(QuotaExceedComponent, { width: '650px' });
              if(this.authService.isUserLoggedIn()) {
                this.dialogRef.componentInstance.message = this.msg1;
                this.dialogRef.componentInstance.title = this.title1;
                this.dialogRef.componentInstance.navigateTo = { title: 'My Packages', route: '/my-packages' };
              }
              if(!this.authService.isUserLoggedIn()) {
                this.dialogRef.componentInstance.message = this.msg2;
                this.dialogRef.componentInstance.title = this.title2;
                this.dialogRef.componentInstance.navigateTo = { title: 'Go to Login', route: '/login' };
              }
              this.dialogRef.afterClosed().subscribe(result => {
                this.dialogRef = null;
              });
            }
          } else if(!this.authService.isUserLoggedIn()) {
            let shortenedS3 = 'https://mspro-shortened.s3.';
            let currentTrackUrl: string = currentSong.mp3_url.split('.s3.')[1];
            soundManager.sounds[trackId].url = currentSong.mp3_url.replace(/http/gi, "https"); //shortenedS3 + currentTrackUrl;
          } else {
            soundManager.sounds[trackId].url = currentSong.mp3_url.replace(/http/gi, "https");
          }
          soundManager.play(trackId);
          this.playerEvent.emit({ type: 'track:id', data: trackId });
          this.isPlaying = true;
          this.playerEvent.emit({ type: 'music:isPlaying', data: this.isPlaying });
        });
      } else {
        if(currentSong._type !== 'playlist' && currentSong.type !== 'R') {
          soundManager.sounds[trackId].url = currentSong.mp3_url.replace(/http/gi, "https");
        } else if(currentSong._type == 'playlist' && currentSong.type == 'R') {
          this.userService.userSongsPlayedCount().subscribe((res) => {
            console.log("Radio checks" + res);
            localStorage.setItem("realCount", (res.count));
            if(res && res.count && res.limit != -1 && (parseInt(res.count) >= parseInt(res.limit))) {
              this.nowListen = this.nowListen + 1;
              localStorage.setItem("listenCount", (this.nowListen) + "");
              let Nowcount: number = parseInt(localStorage.getItem("listenCount"));
              if((Nowcount + parseInt(res.limit)) == parseInt(res.limit) + 1) {
                this.dialogRef = this.dialog.open(QuotaExceedComponent, { width: '650px' });
                if(this.authService.isUserLoggedIn()) {
                  this.dialogRef.componentInstance.message = this.msg1;
                  this.dialogRef.componentInstance.title = this.title1;
                  this.dialogRef.componentInstance.navigateTo = { title: 'My Packages', route: '/my-packages' };
                }
                this.dialogRef.afterClosed().subscribe(result => {
                  this.dialogRef = null;
                });
              }
            }
          });
        }
        soundManager.play(trackId);
        this.playerEvent.emit({ type: 'track:id', data: trackId });
        this.isPlaying = true;
        this.playerEvent.emit({ type: 'music:isPlaying', data: this.isPlaying });
      }
      /* Making sure about users's limit an sending demo song if the limit is exceeded */
    } else {
      //play it
      soundManager.play(trackId);
      this.playerEvent.emit({ type: 'track:id', data: trackId });
      this.isPlaying = true;
      this.playerEvent.emit({ type: 'music:isPlaying', data: this.isPlaying });
    }
  }

  /**
  * Play
  */
  play() {
    let trackToPlay = null;
    //check if no track loaded, else play loaded track
    if (this.getCurrentTrack() === null) {
      if (soundManager.soundIDs.length === 0) {
        return;
      }
      trackToPlay = soundManager.soundIDs[0];
      this.initPlayTrack(trackToPlay);
    } else {
      trackToPlay = this.getCurrentTrack();
      this.initPlayTrack(trackToPlay, true);
    }
  }

  /**
  * Pause
  */
  pause() {
    this.logTimePlayed();
    soundManager.pause(this.getCurrentTrack());
    //set as not playing
    this.isPlaying = false;
    this.playerEvent.emit({ type: 'music:isPlaying', data: this.isPlaying });
  }

  /**
  * Stop
  */
  stop() {
    this.logTimePlayed();
    //first pause it
    this.pause();
    this.resetProgress();
    this.playerEvent.emit({ type: 'track:progress', data: this.trackProgress });
    this.playerEvent.emit({ type: 'currentTrack:position', data: 0 });
    this.playerEvent.emit({ type: 'currentTrack:duration', data: 0 });
    //we are gonna update the seekbar so that it can make it perfect....
    soundManager.stopAll();
    soundManager.unload(this.getCurrentTrack());
    this.adjustSeekBarSlider(0);
  }

  /**
  * Play Track
  */
  playTrack(trackId, objct?: any) {
    this.initPlayTrack(trackId);
    // lets log
    let share_id = '-1';
    if ((localStorage.getItem('share_id') != null)) {
      share_id = localStorage.getItem('share_id');
      localStorage.setItem('share_id', '-1');
    }
    let currentSong = this.currentTrackData();
    // if song is played from album and its first song in album
    if (typeof (currentSong.logData) !== 'undefined' && typeof (currentSong.logData.playedFrom) !== 'undefined' && currentSong.logData && currentSong.logData.playedFrom) {
      let params;
      if (currentSong.logData.playedFrom === 'album') {
        params = { indication_1: currentSong.id, indication_2: currentSong.album_id, domain_2: 'c', share_id: share_id };
      } else if (currentSong.logData.playedFrom === 'artist') {
        params = { indication_1: currentSong.id, indication_2: currentSong.artist_id, domain_2: 'a', share_id: share_id };
      } else if (currentSong.logData.playedFrom === 'playlist') {
        params = { indication_1: currentSong.id, indication_2: currentSong.logData.playlistId, domain_2: 'p', share_id: share_id };
      } else {
        params = { indication_1: currentSong.id, share_id: share_id };
      }
      this.loggingService.logEntity('song', params).subscribe((res) => {
        localStorage.setItem('played_' + currentSong.id, res);
      });
    }
  }

  /**
    * Next Track
    */
  nextTrack2() {
    let currentTrackKey = this.getIndexByValue(soundManager.soundIDs, this.getCurrentTrack());
    let nextTrackKey = +currentTrackKey + 1;
    let nextTrack = soundManager.soundIDs[nextTrackKey];
    let currentKey = this.isInArray(this.playlist, nextTrack);
    return this.playlist[currentKey];
  }

  /**
  * Next Track
  */
  nextTrack(nextSong?: any) {
    this.logTimePlayed();
    if (this.getCurrentTrack() === null) {
      return null;
    }
    let currentTrackKey = this.getIndexByValue(soundManager.soundIDs, this.getCurrentTrack());
    let nextTrackKey = +currentTrackKey + 1;
    let nextTrack = soundManager.soundIDs[nextTrackKey];
    if ((nextTrack && nextSong) || (nextTrack && this.repeat == null)) {
      let currentKey = this.isInArray(this.playlistQue, nextTrack);
      var i = nextTrackKey;
      while (currentKey == null) {
        if (i < soundManager.soundIDs.length) {
          nextTrackKey = nextTrackKey + 1;
          nextTrack = soundManager.soundIDs[nextTrackKey];
          if (this.playlist.length == 0) {
            this.playlist = this.playlistQue;
          }
          currentKey = this.isInArray(this.playlist, nextTrack);
          i++;
        }
        else {
          currentKey = -1;
        }
      }
      if (currentKey != -1) {
        if (typeof nextTrack !== 'undefined') {
          this.playTrack(nextTrack);
        } else {
          //if no next track found
          if (this.repeat === true) {
            //start first track if repeat is on
            this.playTrack(soundManager.soundIDs[currentTrackKey]);
          } else {
            //breadcase not playing anything
            this.isPlaying = false;
            this.playerEvent.emit({ type: 'music:isPlaying', data: this.isPlaying });
          }
        }
      } else {
        if (this.repeat === true) {
          //start first track if repeat is on
          this.playTrack(soundManager.soundIDs[currentTrackKey]);
        }
        console.log("No next song");
      }
    }
    else {
      if (this.repeat === true) {
        //start first track if repeat is on
        if (!nextSong) {
          this.playTrack(soundManager.soundIDs[currentTrackKey]);
        } else {
          this.isPlaying = false;
          this.playerEvent.emit({ type: 'music:isPlaying', data: this.isPlaying });
        }
      } else if (this.repeat === false) {
        if ((nextTrack && nextSong) || (nextTrack && this.repeat == false)) {
          let currentKey = this.isInArray(this.playlistQue, nextTrack);
          var i = nextTrackKey;
          while (currentKey == null) {
            if (i < soundManager.soundIDs.length) {
              nextTrackKey = nextTrackKey + 1;
              nextTrack = soundManager.soundIDs[nextTrackKey];
              if (this.playlist.length == 0) {
                this.playlist = this.playlistQue;
              }
              currentKey = this.isInArray(this.playlist, nextTrack);
              i++;
            }
            else {
              currentKey = -1;
            }
          }
          if (currentKey != -1) {
            if (typeof nextTrack !== 'undefined') {
              this.playTrack(nextTrack);
            }
          }
        } else {
          this.playTrack(soundManager.soundIDs[0]);
        }

      }
      console.log("No next song");
      // to hide the player when there is no next song
      this.currentTrack = null;
      console.log('closed');
      this.isSongPlayingStatus.next(false);
    }
  }

  /**
  * Previous Track
  */
  prevTrack() {
    this.logTimePlayed();
    if (this.getCurrentTrack() === null) {
      return null;
    }
    let currentTrackKey = this.getIndexByValue(soundManager.soundIDs, this.getCurrentTrack());
    let prevTrackKey = +currentTrackKey - 1;
    let prevTrack = soundManager.soundIDs[prevTrackKey];
    if (prevTrack) {
      if (this.playlist.length == 0) {
        this.playlist = this.playlistQue;
      }
      let currentKey = this.isInArray(this.playlist, prevTrack);
      var i = 0;
      while (currentKey == null) {
        i = this.playlist.length;
        if (i > 0) {
          prevTrackKey = prevTrackKey - 1;
          prevTrack = soundManager.soundIDs[prevTrackKey];
          if (this.playlist.length == 0) {
            this.playlist = this.playlistQue;
          }
          currentKey = this.isInArray(this.playlist, prevTrack);
          i--;
        }
        else {
          currentKey = -1;
        }
      }
      if (currentKey != -1) {
        if (typeof prevTrack !== 'undefined') {
          this.playTrack(prevTrack);
        } else {
          // console.log('no prev track found!');
        }
      } else {
        // return null;
        console.log("No previous song");
      }
    } else {
      console.log("No previous song");
    }
  }

  /**
  * Previous Track
  */
  mute() {
    if (soundManager.muted === true) {
      soundManager.unmute();
      // to adjust the volume seek bar back to its position
      this.adjustVolumeSlider(this.vol);
      localStorage.setItem('volumePreference', '' + this.vol);
    } else {
      let localStorageVolume = parseInt(localStorage.getItem('volumePreference'));
      if(localStorageVolume) {
        this.vol = localStorageVolume
      }
      soundManager.mute();
    }
    this.playerEvent.emit({ type: 'music:mute', data: soundManager.muted });
  }

  /**
  * Get Mute Status
  */
  getMuteStatus() {
    return soundManager.muted;
  }

  /**
  * Repeat Toggle
  */
  repeatToggle() {
    switch (this.repeat) {
      case null:
        this.repeat = true;
        break;
      case true:
        this.repeat = false;
        break;
      case false:
        this.repeat = null;
    }

    this.playerEvent.emit({ type: 'music:repeat', data: this.repeat });
  }

  /**
  * Get Repeat Status
  */
  getRepeatStatus() {
    return this.repeat;
  }

  /**
  * Get Volume
  */
  getVolume() {
    return this.volume;
  }

  /**
  * Adjust Volume
  */
  adjustVolume(increase) {
    let changeVolume = function (volume) {
      for (let i = 0; i < soundManager.soundIDs.length; i++) {
        let mySound = soundManager.getSoundById(soundManager.soundIDs[i]);
        mySound.setVolume(volume);
      }
      this.playerEvent.emit({ type: 'music:volume', data: this.volume });
    };
    if (increase === true) {
      if (this.volume < 100) {
        this.volume = this.volume + 10;
        changeVolume(this.volume);
      }
    } else {
      if (this.volume > 0) {
        this.volume = this.volume - 10;
        changeVolume(this.volume);
      }
    }
  }

  /**
  * Adjust Volume Slider
  */
  adjustVolumeSlider(value) {
    let changeVolume = (volume) => {

      for (let i = 0; i < soundManager.soundIDs.length; i++) {
        let mySound = soundManager.getSoundById(soundManager.soundIDs[i]);
        mySound.setVolume(volume);
      }
      this.playerEvent.emit({ type: 'music:volume', data: volume });
    };
    changeVolume(value);
    soundManager.unmute();
  }

  /*
   * IF WE CLEAR QUEUE ,THEN IT WILL CLOSE NAV AND PLAYER THIS WILL RETURN PLAYLIST LENGTH.
   */
  plyalistLength() {
    return this.playlist.length;
  }

  /**
  * Adjust SeekBar Slider
  */
  adjustSeekBarSlider(value) {
    let changePosition = (position) => {

      for (let i = 0; i < soundManager.soundIDs.length; i++) {
        let mySound = soundManager.getSoundById(soundManager.soundIDs[i]);
        mySound.setPosition(position);
      }
      this.playerEvent.emit({ type: 'currentTrack:position', data: position });
    };
    changePosition(value);
  }

  /**
  * Clear Playlist
  */
  clearPlaylist(callback) {
    let that = this;
    this.resetProgress();
    //unload and destroy soundmanager sounds
    let smIdsLength = soundManager.soundIDs.length;
    this.asyncLoop({
      length: smIdsLength,
      functionToLoop: function (loop, i) {
        setTimeout(function () {
          //custom code
          soundManager.destroySound(soundManager.soundIDs[0]);
          //custom code
          loop();
        }, 100);
      },
      callback() {
        //callback custom code
        console.log('All done!');
        //clear playlist
        that.playlist = [];
        that.playerEvent.emit({ type: 'player:playlist', data: that.playlist });
        that.playerEvent.emit({ type: 'currentTrack:position', data: 0 });
        that.playerEvent.emit({ type: 'currentTrack:duration', data: 0 });
        callback(true);
        //callback custom code
      }

    });
    this.playlistQue = [];
    this.playerEvent.emit({ type: 'player:playlist', data: this.playlistQue });
    this.playingId = 0;
  }

  /**
  * Reset Progress
  */
  resetProgress() {
    this.trackProgress = 0;
  }

  /**
  * Reset Progress
  */
  isPlayingStatus() {
    return this.isPlaying;
  }

  isTrackAlreadyInQueue(track) {
    let inArrayKey = this.isInArray(this.getPlaylist(), track.id);
    if (inArrayKey === null) {
      return false;
    }
    return true;
  }

  isPlaylistAlreadyInQueue(playlist) {
    let inArrayKey = this.isInArray(this.playlistList, playlist.id);
    if (inArrayKey === null) {
      return false;
    }
    return true;
  }

  makePlaylistEmpty() {
    this.playlist = [];
  }

  showLoading(show: boolean) {
    this.loading = show;
  }

  getLoadingStatus() {
    if (this.loading == false) {
      /*this.blockUI.stop();*/
    }
    return this.loading;
  }

  playRadio(item) {
    var radioCheck = false;
    let radioUrl = new Globals().radioEndpoint + item.slug + ".ogg"; // hardcoding ogg because it's
    let url = 'radio/get-url-status/?url=' + radioUrl;
    this.api.get(url).toPromise().then((data) => {
      if (data.response == "true") {
        item.mp3_url = radioUrl;
        item.radioSlug = item.slug;
        item.belongsToRadio = true;
        let trackId = this.addTrack(item);
        // this.play(); // here comes the radio....
        this.playTrack(trackId);
        this.emitRadioConnected(radioUrl);
        let params = {
          indication_1: item.id,
        };
        this.loggingService.logEntity('radio', params).subscribe((res) => { this.blockUI.stop(); });
      }
      else {
        this.dialogRef = this.dialog.open(RadioServerBusyDialog, { width: '640px' });
        this.dialogRef.componentInstance.name = item.name;
      }
    });
  }

  logRadioActions(radioObj) {
    let params = {
      domain_2: 'r',
      indication_2: radioObj.id,
      indication_1: (radioObj.metaData) ? radioObj.metaData.id : '',
      played_from: 'r'
    };
    setTimeout(() => {
      this.blockUI.stop();
    }, 1500)
    this.loggingService.logEntity('song', params).subscribe((res) => {
    });
  }

  emitRadioConnected(listenUrl: string) {
    let radioStation = this.searchUrl(listenUrl);
    this.sendRadioSongInfo(radioStation);
  }

  searchUrl(listenUrl) {
    let partsOfStr;
    if (listenUrl) {
      partsOfStr = listenUrl.split('/');
    }
    let songOgg;
    let lastindex;
    if (partsOfStr) {
      lastindex = partsOfStr.length - 1;
      songOgg = partsOfStr[lastindex];
    }

    for (let index = 0; index < this.radioStations.length; ++index) {
      let subArray = this.radioStations[index];
      let listenurl = subArray["listenurl"];
      if (listenurl.indexOf(songOgg) !== -1) {
        return subArray;
      }
    }
  }

  oggUrl(listenUrl) {
    if (listenUrl) {
      let partsOfStr = listenUrl.split('/');
      let lastindex = partsOfStr.length - 1;
      return partsOfStr[lastindex];
    } else {
      return '';
    }
  }

  getRadioCurrentSong(listenUrl, returnObject = false) {
    let radioStation = this.searchUrl(listenUrl);
    if (returnObject === true) {
      return radioStation.currentSong;
    }
    if (radioStation && radioStation.currentSong && radioStation.currentSong.name) {
      let caption = radioStation.currentSong.name;
      if (radioStation.currentSong.artist) {
        caption += ' - ' + radioStation.currentSong.artist.name;
      }
      return caption;
    } else {
      return 'N-A';
    }
  }

  getRadioCurrentSongName(listenUrl, returnObject = false) {
    let radioStation = this.searchUrl(listenUrl);
    if (returnObject === true) {
      return radioStation.currentSong;
    }
    if (radioStation && radioStation.currentSong && radioStation.currentSong.name) {
      let caption = radioStation.currentSong.name;
      return caption;
    } else {
      return 'N-A';
    }
  }

  getRadioCurrentsong(listenUrl, returnObject = false) {
    let radioStation = this.searchUrl(listenUrl);
    if (returnObject === true) {
      return radioStation.currentSong;
    }
    if (radioStation && radioStation.currentSong && radioStation.currentSong.id) {
      let caption = radioStation.currentSong;
      return caption;
    } else {
      return false;
    }
  }

  getRadioCurrentSongArtistName(listenUrl, returnObject = false) {
    let radioStation = this.searchUrl(listenUrl);
    if (returnObject === true) {
      return radioStation.currentSong;
    }
    if (radioStation && radioStation.currentSong && radioStation.currentSong.name) {
      let caption = "";
      if (radioStation.currentSong.artist && radioStation.currentSong.artist.name) {
        caption = radioStation.currentSong.artist.name;
      }
      return caption;
    } else {
      return 'N-A';
    }
  }

  getRadioCurrentSong1(listenUrl, returnObject = false) {
    let radioStation = this.searchUrl(listenUrl);
    if (returnObject === true) {
      return radioStation.currentSong;
    }
    if (radioStation && radioStation.currentSong && radioStation.currentSong.name) {
      let caption = radioStation.currentSong.id;
      return caption;
    } else {
      return 'N-A';
    }
  }

  broadcastRadioSongDetail(data) {
    let radioStation = _.find(this.radioStations, {
      listenurl: data.listenurl
    });

    if (this.currentTrackData() && this.oggUrl(this.currentTrackData().mp3_url) === this.oggUrl(data.listenurl) && data.songDetail) {
      this.currentTrackData().metaData = data.songDetail;
      this.playerEvent.emit({ type: 'track:id', data: data.songDetail.id });
      this.logRadioActions(this.currentTrackData());
    }
    this.showLoading(false);
  }

  // this function is used to play a radio bypassing the radio button .. used from my music library
  playSpecificRadio(radioId) {
    this.playlistService.getPlaylistDetailsByIds([radioId]).subscribe((res) => {
      if (res[0] && res[0].id) {
        this.playRadio(res[0]);
      }
    });
  }

  // forward the song by 10 seconds
  onForward() {
    // increasing the track position by 10 seconds
    this.trackPostion = this.trackPostion + 10000;
    // set the track progress according to the new position
    this.trackProgress = ((this.trackPostion / this.songDuration) * 100);
    this.playerEvent.emit({ type: 'track:progress', data: this.trackProgress });
    // set the seek bar move it forward by 10 seconds
    this.adjustSeekBarSlider(this.trackPostion);
  }

  // backward the song by 10 seconds
  onBackward() {
    if (this.trackPostion >= 10000) {
      // decrease the track position by 10 seconds
      this.trackPostion = this.trackPostion - 10000;
      // set the track progress according to the new position
      this.trackProgress = ((this.trackPostion / this.songDuration) * 100);
      this.playerEvent.emit({ type: 'track:progress', data: this.trackProgress });
      // set the seek bar move it forward by 10 seconds
      this.adjustSeekBarSlider(this.trackPostion);
    }
  }
}


@Component({
  selector: 'quota-exceed-dialog',
  template: `<md-toolbar color="primary">
  <span>{{ title }}</span>
  <span class="demo-fill-remaining"></span>
  <span>
    <a>
      <md-icon svgIcon="ic_close_24px.svg" (click)="dialogRef.close()" mdTooltip="{{ 'CLOSE' | tooltip }} " mdTooltipPosition="above"> </md-icon>
    </a>
  </span>
</md-toolbar>
<div class="modal-content">
  <div fxLayout='row'>
    {{ message }}
  </div>
  <div fxLayout='row' style='margin: 10px;text-align: right;' *ngIf='navigateTo.route && navigateTo.title'>
    <div fxFlex='100'>
      <button md-raised-button color="primary" (click)='navigate(navigateTo.route)'>{{ navigateTo.title }}</button>
    </div>
  </div>
</div>`,
  styles: ['']
})

export class QuotaExceedComponent {
  public title: string = 'Song Quota Exceeded!';
  public message: string = "You have exceeded your download limit, the song has been added to the shopping cart.Please Subscribe new package"
  public navigateTo = { title: '', route: '' };

  constructor(public dialogRef: MdDialogRef<any>, private router: Router) {
  }

  navigate(route) {
    this.dialogRef.close();
    this.router.navigate([route]);
  }
}

@Component({
  selector: 'trail-dialog',
  template: `
  <md-toolbar color="primary">
  <span>Trial Period Activated</span>
  <span class="demo-fill-remaining"></span>
  <span>
    <a>
      <md-icon svgIcon="ic_close_24px.svg" (click)="dialogRef.close()" mdTooltip="{{ 'CLOSE' | tooltip }} " mdTooltipPosition="above"> </md-icon>
    </a>
  </span>
</md-toolbar>
<div fxLayout="column" fxLayout.gt-md="row"  class="modal-content" >
<br>
  It seems that one of your current packages has expired and you are on trial period. Please re-subscribe a new package for uninterupted song listening.
  <br><br>
 </div>`
})
export class TrailPeriodComponent {
  constructor(public dialogRef: MdDialogRef<any>) { }
}

@Component({
  selector: 'radio-server-busy-dialog',
  template: `<md-toolbar color="primary">
  <span> Radio station '{{ this.name }}' is busy or down, please try again later!</span>
  <span class="demo-fill-remaining"></span>
  <span>
    <a>
      <md-icon svgIcon="ic_close_24px.svg" (click)="closeDialog()" mdTooltip="{{ 'CLOSE' | tooltip }} " mdTooltipPosition="above"> </md-icon>
    </a>
  </span>
</md-toolbar>
<!--<div class="modal-content">-->
  <!--<div fxLayout='row'>-->
    <!--{{ message }}-->
  <!--</div>-->
  <!--<div fxLayout='row' style='margin: 10px;text-align: right;' *ngIf='navigateTo.route && navigateTo.title'>-->
    <!--<div fxFlex='100'>-->
      <!--<button md-raised-button color="primary" (click)='navigate(navigateTo.route)'>{{ navigateTo.title }}</button>-->
    <!--</div>-->
  <!--</div>-->
<!--</div>-->
`,
  styles: ['']
})

export class RadioServerBusyDialog {
  public name: string = "";
  public title: string = "";
  @BlockUI() blockUI: NgBlockUI;
  public navigateTo = { title: '', route: '' };

  constructor(public dialogRef: MdDialogRef<any>, private router: Router) {
    this.title = "";
  }

  closeDialog() {
    this.blockUI.stop();
    this.dialogRef.close();
  }

  navigate(route) {
    this.dialogRef.close();
    this.router.navigate([route]);
  }

}



// WEBPACK FOOTER //
// ./src/app/player/services/player.service.ts